export const ENTIRE_CHALLENGE = 'entireChallenge';
export const THEMES_ONLY = 'themesOnly';
export const TOAST_SUCCESS = 'notification_person.png';
export const TOAST_FAILED = 'notification_fail.png';
